import { createFileRoute, notFound } from '@tanstack/react-router';

import { buildGuards, hasFlagEnabled } from '@mint-lib/routing-guards';

const guard = buildGuards(hasFlagEnabled('testigos'));

export const Route = createFileRoute('/_secured/testigos/')({
  async beforeLoad({ context }) {
    const guardsContext = await context.getGuardContext(
      await context.getInstance('flagsmith', '@mint/arm'),
    );
    if (!guard(guardsContext)) {
      throw notFound();
    }
  },
});
